(function () {
  var NAV_STACK_KEY = 'devora-nav-stack';
  var NAV_STACK_MAX = 30;

  function navStackRead() {
    try {
      var raw = sessionStorage.getItem(NAV_STACK_KEY);
      var stack = raw ? JSON.parse(raw) : [];
      return Array.isArray(stack) ? stack : [];
    } catch (error) {
      return [];
    }
  }

  function navStackWrite(stack) {
    try {
      sessionStorage.setItem(NAV_STACK_KEY, JSON.stringify(stack.slice(-NAV_STACK_MAX)));
    } catch (error) {
      /* ignore quota / private mode */
    }
  }

  function navCurrentPath() {
    return window.location.pathname + window.location.search + window.location.hash;
  }

  function navRecordPage() {
    var path = navCurrentPath();
    var stack = navStackRead();
    if (stack[stack.length - 1] === path) return;
    stack.push(path);
    navStackWrite(stack);
  }

  function navPreviousFromStack() {
    var stack = navStackRead();
    if (stack.length < 2) return null;
    stack.pop();
    var previous = stack[stack.length - 1];
    navStackWrite(stack);
    return previous || null;
  }

  function initNavBack() {
    navRecordPage();

    document.querySelectorAll('[data-devora-nav-back]').forEach(function (btn) {
      if (btn.dataset.devoraNavBackBound === 'true') return;
      btn.dataset.devoraNavBackBound = 'true';

      btn.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();

        var fromStack = navPreviousFromStack();
        if (fromStack) {
          window.location.assign(fromStack);
          return;
        }

        var referrer = document.referrer || '';
        if (referrer.indexOf(window.location.origin) === 0 && referrer !== window.location.href) {
          window.location.assign(referrer);
          return;
        }

        if (window.history.length > 1) {
          window.history.back();
          window.setTimeout(function () {
            if (document.visibilityState === 'visible') {
              window.location.assign(btn.getAttribute('data-fallback') || '/');
            }
          }, 400);
          return;
        }

        window.location.assign(btn.getAttribute('data-fallback') || '/');
      });
    });
  }

  function initDesktopMegaMenus() {
    var root = document.querySelector('[data-devora-mega-panels]');
    if (!root || root.dataset.devoraMegaBound === 'true') return;
    root.dataset.devoraMegaBound = 'true';

    var triggers = document.querySelectorAll('[data-devora-mega-trigger]');
    var panels = root.querySelectorAll('[data-devora-mega]');
    var openKey = null;
    var closeTimer = null;
    var canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

    function panelFor(key) {
      return root.querySelector('[data-devora-mega="' + key + '"]');
    }

    function setOpen(key) {
      clearTimeout(closeTimer);
      openKey = key || null;

      triggers.forEach(function (trigger) {
        var active = trigger.getAttribute('data-devora-mega-trigger') === openKey;
        trigger.classList.toggle('is-open', active);
        trigger.setAttribute('aria-expanded', active ? 'true' : 'false');
      });

      panels.forEach(function (panel) {
        var active = panel.getAttribute('data-devora-mega') === openKey;
        panel.hidden = !active;
        panel.classList.toggle('is-open', active);
      });

      document.documentElement.classList.toggle('devora-mega-open', Boolean(openKey));
    }

    function scheduleClose() {
      clearTimeout(closeTimer);
      closeTimer = setTimeout(function () {
        setOpen(null);
      }, 160);
    }

    triggers.forEach(function (trigger) {
      var key = trigger.getAttribute('data-devora-mega-trigger');
      var toggle = trigger.querySelector('[data-devora-mega-toggle]');

      if (canHover) {
        trigger.addEventListener('mouseenter', function () {
          setOpen(key);
        });
        trigger.addEventListener('mouseleave', scheduleClose);
      }

      if (toggle) {
        toggle.addEventListener('click', function (event) {
          event.preventDefault();
          setOpen(openKey === key ? null : key);
        });
      }
    });

    panels.forEach(function (panel) {
      panel.addEventListener('mouseenter', function () {
        clearTimeout(closeTimer);
      });
      panel.addEventListener('mouseleave', scheduleClose);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') setOpen(null);
    });

    document.addEventListener('click', function (event) {
      if (!openKey) return;
      if (event.target.closest('[data-devora-mega-trigger], [data-devora-mega-panels]')) return;
      setOpen(null);
    });
  }

  /* Theme only binds expand to .dropdown > a .icon — make the whole row toggle. */
  function initMobileNavAccordion() {
    var root = document.querySelector('.mobile-dropdown');
    if (!root || root.dataset.devoraAccordionBound === 'true') return;
    root.dataset.devoraAccordionBound = 'true';

    root.addEventListener(
      'click',
      function (event) {
        var link = event.target.closest('.list-item.dropdown > a');
        if (!link || !root.contains(link)) return;

        /* Let the theme icon handler run when the +/- hit area is tapped. */
        if (event.target.closest('.icon')) return;

        var href = (link.getAttribute('href') || '').trim();
        var isToggleOnly = !href || href === '#' || href.indexOf('javascript:') === 0;
        if (!isToggleOnly) return;

        event.preventDefault();
        event.stopPropagation();

        var icon = link.querySelector('.icon');
        if (icon) {
          /* Native .click() so the theme's jQuery handler on .icon fires. */
          icon.click();
        }
      },
      true
    );
  }

  document.addEventListener('DOMContentLoaded', function () {
    initNavBack();
    initDesktopMegaMenus();
    initMobileNavAccordion();
  });
})();
